import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from './notAvailable.module.css';

const mapStateToProps = ({ language }) => ({
  notAvailablePageTitle: language['returns.not_available_page.title'],
  notAvailablePageContent: language['returns.not_available_page.content'],
});

const Component = ({ notAvailablePageTitle, notAvailablePageContent }) => (
  <div className={s.not_available_container}>
    <div className={s.not_available_message}>
      <i className="fa fa-file-o fa-4x" aria-hidden="true" />
      <h4>{notAvailablePageTitle}</h4>
      <p className={s.not_available_text}>{notAvailablePageContent}</p>
    </div>
  </div>
);

Component.defaultProps = {
  notAvailablePageTitle: 'Page not Found',
  notAvailablePageContent:
    'Information about this return is no longer available at this URL. For assistance, please contact customer support.',
};

Component.propTypes = {
  notAvailablePageTitle: PropTypes.string,
  notAvailablePageContent: PropTypes.string,
};

export const NotAvailable = connect(mapStateToProps)(Component);
